import {Base} from '../../common/model/base.model';
import {Helpers} from '../../common/helpers/helpers';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Persona} from '../../+anagrafica/persona/persona.model';

export class Utente extends Base {

  constructor(protected id: number,
              public username: string,
              public email: string,
              public scadAccount: Date,
              public ultimoAccesso: Date,
              public indirizzoUltimoAccesso: string,
              public inattivo: boolean,
              public persona: Persona
              ) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'username', 'email', 'nome', 'scadAccount', 'inattivo'];
  }

  public getLabel() {
    return this.username;
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('username', new TableRowValue(this.username, null));
    rowValues.set('email', new TableRowValue(this.email, null));
    rowValues.set('nome', new TableRowValue(this.persona ? this.persona.getLabel() : null, null));
    rowValues.set('scadAccount', new TableRowValue(this.scadAccount ? Helpers.formatDateView(this.scadAccount) : null, null));
    rowValues.set('ultimoAccesso', new TableRowValue(this.ultimoAccesso ? Helpers.formatDateTimeView(this.ultimoAccesso) : null, null));
    rowValues.set('indirizzoUltimoAccesso', new TableRowValue(this.indirizzoUltimoAccesso, null));
    rowValues.set('inattivo', new TableRowValue(this.inattivo, null));
    return new TableRow(this, rowValues);
  }

}
